// extracted by mini-css-extract-plugin
module.exports = {"mainHeader":"header-module--mainHeader--iOwMK","profileImg":"header-module--profileImg--1lmKe","profileDescription":"header-module--profileDescription--1S5HI"};